import React from 'react';
import Sidebar from '../../Component/sidebar';
import { Route, Routes } from "react-router-dom";
import { PublicationData } from '../../module/publicationData';
import CreateSellingSource from './sellingSource/createSellingSource';
import EditSellingSource from './sellingSource/editSellingSource';
import CreateTds from './TDS/createTds';
import EditTds from './TDS/editTds';
import Vendor from './vendor';
import DispatchOrder from './dispatchOrders/dispatchOrders';
import StockIn from './BookManagment/stockIn';
import TransferStock from './BookManagment/transferStock';
import OrderReturn from './BookManagment/orderReturn';
import SellStock from './BookManagment/sellStock';
import DamageIn from './BookManagment/damageIn';
import ProdctHistory from './BookManagment/prodctHistory';
import DamageStock from './BookManagment/damageStock';
const PublicationDashBoard = () => {
    return (
        <>
            <div className="adminDiv d-flex">
                <Sidebar data={PublicationData} />
                <div className="rightSideContainer py-3 px-4">
                    <Routes>
                        <Route path="/" element={<CreateSellingSource />} />
                        <Route path="createSellingSource" element={<CreateSellingSource />} />
                        <Route path="editSellingSource" element={<EditSellingSource />} />
                        <Route path="createTds" element={<CreateTds />} />
                        <Route path="editTds" element={<EditTds />} />
                        <Route path="vendor" element={<Vendor />} />
                        <Route path='dispatchOrders' element={<DispatchOrder />} />
                        <Route path="stockIn" element={<StockIn />} />
                        <Route path="transferStock" element={<TransferStock />} />
                        <Route path="orderReturn" element={<OrderReturn />} />
                        <Route path="sellStock" element={<SellStock />} /> 
                        <Route path="damageIn" element={<DamageIn />} />   
                        <Route path="prodctHistory" element={<ProdctHistory />} /> 
                        <Route path="damageStock" element={<DamageStock />} />
                    </Routes>
                </div>
            </div>
        </>
    );
};

export default PublicationDashBoard;
